import customAxios from "../index";


export const createContractTemplate  = (url: string, formData: FormData) => {
  return customAxios({
    method: "POST",
    url,
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const shareContractTemplateToOther  = (url: string,data: any) => {
  return customAxios({
    method: "POST",
    url: `${url}/share`,
    data,
  });
};
export const getContractTemplateList = (url: string,params:any) => {
  return customAxios({
    method: "GET",
    url,
    params,
  });
}

export const getContractTemplate = (url: string,id: number) => {
  return customAxios({
    method: "GET",
     url: `${url}/${id}`,
  });
}

export const updateContractTemplate = (url: string, id: number, data: any) => {
  return customAxios({
    method: "PUT",
    url: `${url}/${id}`,
    data,
  });
}

export const deleteContractTemplate = (url: string,id: number) => {
  return customAxios({
    method: "DELETE",
    url: `${url}/${id}`,
  });
};

export const getDownloadContractTemplateLink = (url: string,id: number) => {
  return customAxios({
    method: "GET",
    url: `${url}/download/${id}`,
  });
};
